import axios from "axios";
import { API_URL } from "@/config";
import downloadFile from "@/utils/downloadFile";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/invoicesFiles`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, invoiceFileId) {
      const response = await axios.get(`${API_URL}/invoicesFiles/${invoiceFileId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, formData) {
      const response = await axios.post(`${API_URL}/invoicesFiles`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async createForTransaction(_, transactionId) {
      const response = await axios.post(
        `${API_URL}/invoicesFiles/createForTransaction/${transactionId}`,
      );

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async createForUser(_, { userId, month }) {
      const response = await axios.post(`${API_URL}/invoicesFiles/createForUser/${userId}`, {
        month,
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async createForInstitution(_, { institutionId, month }) {
      const response = await axios.post(
        `${API_URL}/invoicesFiles/createForInstitution/${institutionId}`,
        { month },
      );

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, invoiceFileId) {
      const response = await axios.delete(`${API_URL}/invoicesFiles/${invoiceFileId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async download(_, invoiceFileId) {
      const response = await axios({
        url: `${API_URL}/invoicesFiles/${invoiceFileId}/download`,
        method: "POST",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      downloadFile(response);

      return true;
    },

    async downloadAll(_, filters) {
      const response = await axios({
        url: `${API_URL}/invoicesFiles/download`,
        method: "POST",
        responseType: "blob",
        withCredentials: true,
        data: filters,
      });

      response.headers["content-disposition"] = "faktury.zip";

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      downloadFile(response);

      return true;
    },

    async getMaxFilesize() {
      const response = await axios.get(`${API_URL}/invoicesFiles/maxFileSize`);

      if (response.status !== 200 || !response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async markAsPaid(_, invoiceFileId) {
      const response = await axios.post(`${API_URL}/invoicesFiles/${invoiceFileId}/markAsPaid`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};
